import React from 'react';
import './ColorChecker.scss'

export const ColorChecker = ({ colors, onClick }) => {
    const handleClick = (color) => {
        onClick(color)
    }
    return (
        <div className="color-checker-container">
            {
                colors.map(color => {
                    return (
                        <div
                            key={color.nombre}
                            style={{ backgroundColor: color.hex }}
                            onClick={() => { handleClick(color) }}
                            className="color-item pointer"></div>
                    )
                })
            }
        </div>
    )
}